import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import InvoiceRegularDiagonal from './invoice-regular-diagonal-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <InvoiceRegularDiagonal {...validProps} />;
}

SvgComponent.iconName = 'invoiceRegularDiagonal';

export const InvoiceRegularDiagonalIcon = svgIconWrapper(SvgComponent);
